export const confirmButtonTypes = {
    delete: 'delete',//删除
    scrap: 'scrap',//报废
    close: 'close'//关闭
}